import Vuex from 'vuex'
import Vue from 'vue'

/**
 * Plugins
 */

import userStoragePlugin from '@/store/plugins/userStorage'
import systemStoragePlugin from '@/store/plugins/systemStorage'
import prescriptionJustificationPlugin from '@/store/plugins/prescriptionJustification'

/**
 * Modules
 */
import notes from './modules/notesStore'
import system from './modules/systemStore'
import general from './modules/generalStore'
import user from './modules/userStore'
import prescription from './modules/prescriptionStore'
import patient from './modules/patientStore'
import patientsList from './modules/patientsListStore'
import todoList from './modules/todoListStore'
import configs from './modules/remoteConfigsStore'
import clinical from './modules/clinicalStore'
import recommendations from './modules/recommendationsStore'
import results from './modules/resultsStore'
import dptActivity from './modules/dptActivityStore'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    notes,
    system,
    general,
    user,
    prescription,
    patient,
    patientsList,
    todoList,
    clinical,
    recommendations,
    results,
    dptActivity,
    configs,
  },
  plugins: [
    userStoragePlugin.plugin, systemStoragePlugin.plugin, prescriptionJustificationPlugin,
  ],
})
